import R from 'ramda';
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, FormControl } from 'react-bootstrap';
import actions from '../../redux/actions';
import Heading from '../Heading';
import NavButtons from '../NavButtons';
import { getUnMatchedClaimants } from '../../utils';

class ClaimantsTransfer extends Component {
  handleTransferType = (e, claimant) => {
    const data = {
      type: e.target.value,
      typeOther: '',
    };
    this.saveData(data, claimant);
  };

  handleTransferTypeOther = (e, claimant) => {
    const data = {
      type: claimant.transfer ? claimant.transfer.type || '' : '',
      typeOther: e.target.value,
    };
    this.saveData(data, claimant);
  };

  saveData = (data, claimant) => {
    let claimants = this.props.fields.claimants || [];

    const index = R.findIndex(R.propEq('id', claimant.id))(claimants);
    if (index !== -1) {
      claimants[index] = { ...claimant, transfer: data };
    } else {
      claimants = [...claimants, { ...claimant, transfer: data }];
    }
    this.props.assignAttribute('claimants', [...claimants]);
  };

  handleNext() {
    const { fields } = this.props;
    const claimants = fields.claimants || [];
    const authors = fields.authors || [];

    this.props.hideAlert();

    const unMatchedClaimants = getUnMatchedClaimants(authors, claimants, true);

    if (unMatchedClaimants.length) {
      const validates = R.filter(
        ({ transfer }) =>
          !transfer ||
          transfer.type === '' ||
          (transfer.type === 'By other' && transfer.typeOther === '')
      )(unMatchedClaimants);

      if (validates.length) {
        this.props.alert('error', 'Please check the required fields.');
      } else {
        this.props.router.push('/copyright-reg/select-other-materials');
      }
    } else {
      this.props.alert('error', 'Please add an claimant at least.');
    }
  }

  renderClaimants() {
    const { fields } = this.props;
    const claimants = fields.claimants || [];
    const authors = fields.authors || [];

    let unMatchedClaimants = _.orderBy(
      getUnMatchedClaimants(authors, claimants, true),
      [(c) => c.firstName],
      ['asc']
    );

    return (
      unMatchedClaimants && (
        <div className="table-container transfer-container">
          <Table>
            <thead>
              <tr>
                <th>First Name</th>
                <th>Middle Name</th>
                <th>Last Name</th>
                <th>Organization</th>
                <th>
                  <span className="text-red">*</span>Transfer Statement
                </th>
                <th>Other</th>
              </tr>
            </thead>
            <tbody>
              {unMatchedClaimants.map((claimant, i) => (
                <tr key={i}>
                  <td>{claimant.firstName}</td>
                  <td>{claimant.middleName}</td>
                  <td>{claimant.lastName}</td>
                  <td className="text-center">{claimant.organization}</td>
                  <td>
                    <FormControl
                      componentClass="select"
                      value={
                        claimant.transfer ? claimant.transfer.type || '' : ''
                      }
                      onChange={(e) => this.handleTransferType(e, claimant)}
                    >
                      <option disabled value="">
                        Select
                      </option>
                      <option>By written agreement</option>
                      <option>By inheritance</option>
                      <option>By other</option>
                    </FormControl>
                  </td>
                  <td>
                    {claimant.transfer &&
                      claimant.transfer.type === 'By other' && (
                        <FormControl
                          type="text"
                          className="input-md"
                          value={claimant.transfer.typeOther || ''}
                          onChange={(e) =>
                            this.handleTransferTypeOther(e, claimant)
                          }
                        />
                      )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )
    );
  }

  render() {
    return (
      <div className="select-work">
        <Heading text="Provide A Transfer Statement" />
        <div className="content">
          <p>
            Based on your answers, it looks like the owners of the work(s) are
            not exactly the same as the listed author(s). The Copyright Office
            requires that you provide a statement to explain how the current
            owners obtained ownership from the original authors.
          </p>

          <p>
            <b>What is a transfer statement?</b>
          </p>
          <p>
            A transfer statement explains how a person/company that was an
            original author transferred their ownership of the copyright(s).
            Please explain how ownership was transferred to/from each
            person/entity below by selecting a transfer statement:
          </p>

          {this.renderClaimants()}

          <br />
          <p>
            The information you provide will be used for your copyright
            application as is. Please be sure to verify that the information is
            accurate and complete now.
          </p>
        </div>
        <div className="step-nav">
          <NavButtons
            direction="back"
            prev={() => this.props.router.goBack()}
          />
          <NavButtons direction="next" next={() => this.handleNext()} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  fields: state.coreg.fields,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  assignAttribute: (field, attribute) => {
    dispatch(actions.assignCoregAttribute(field, attribute));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ClaimantsTransfer);



// WEBPACK FOOTER //
// src/components/Copyright/ClaimantsTransfer.jsx